import Vue from 'vue'
import App from './App.vue'
import Vuex from 'vuex'
import router from './router'
import store from './store';
import vuetify from './plugins/vuetify'
import i18n from './i18n'
import VueApexCharts from "vue-apexcharts";
import axios from 'axios';
import VueWysiwyg from '@mycure/vue-wysiwyg';
import FloatingVue from 'floating-vue'
import constants from './assets/js/constants';

import VueSignature from "vue-signature-pad";
import VueCropper from 'vue-cropper';

Vue.use(VueCropper);
Vue.use(VueSignature);


const urlSearchParams = new URLSearchParams(window.location.search);
const obfuscatedDocId  = urlSearchParams.get('docId');
const obfuscatedTrasferId = urlSearchParams.get('transferId');
const encDocId = urlSearchParams.get('encDocId');
const encTransferId = urlSearchParams.get('encTransferId');

try {
    if (obfuscatedDocId  !== null && obfuscatedDocId  !== undefined) {
        const docId = atob(obfuscatedDocId);
        sessionStorage.setItem('docId', docId);
    }
    if(obfuscatedTrasferId != null && obfuscatedTrasferId != undefined){
      const transferId = atob(obfuscatedTrasferId);
      sessionStorage.setItem('transferId',transferId);
    }
    if(encDocId != null && encDocId != undefined){
        sessionStorage.setItem('encDocId',encDocId);
    }
    if(encTransferId != null && encTransferId != undefined){
        sessionStorage.setItem('encTransferId',encTransferId);
    } 
  } catch (error) 
  {
    console.error('Error decoding obfuscatedDocId:', error);
  }
axios.defaults.headers = {
    Accept: 'application/json; charset=utf-8',
    'Cache-Control': 'no-cache',
    'Pragma': 'no-cache',
    'Expires': '-1'
}

axios.interceptors.request.use(
    (config) => 
    {
        config.headers['Accept-Language'] = localStorage.getItem('lang')
        
        let token = sessionStorage.getItem('jwt_token')
        if (token)
            config.headers['Authorization'] = `Bearer ${token}`;
        
        config.headers['ApplicationName'] = 'CTS Web'

        return config
    },
    (error) => {
        return Promise.reject(error)
    }
)

axios.interceptors.response.use(undefined, function (error) {
    if (error) 
    { 
        let user = JSON.parse(localStorage.getItem("user")) 
        if (error.request.responseURL.lastIndexOf('api/ListStructuresByIds') !== -1 && error.response.status === 401)
        {
            if(user!=null){document.getElementById('logout').click();}
            else{document.getElementById('login').click();} 
        } 
        
        if(error && error.response && error.response.status == 401){
            if(user!=null){document.getElementById('logout').click();}
            else{document.getElementById('login').click();} 
        }
    }
});

Vue.config.productionTip = false

Vue.use(VueApexCharts)
Vue.use(VueWysiwyg)
Vue.use(FloatingVue)

Vue.component('apexchart', VueApexCharts)

axios.get(sessionStorage.getItem('customApiPath') + 'StructureUser/GetCurrentUserInfo')
    .then(res => 
    {
        var user = JSON.parse(sessionStorage.getItem("user"))
        if (user != null)
        {
            user.profile.DisplayName = res.data.displayName
            user.profile.StructureId = res.data.structureId;
            user.profile.IsNeedResetSignaturePin = res.data.isNeedResetSignaturePin;
            user.profile.EditSigned = res.data.editSigned
            sessionStorage.setItem("user", JSON.stringify(user))
            document.title = constants.applicationTitle
    
            const app = new Vue({
                render: h => h(App),
                router,
                store,
                vuetify,
                i18n
            }).$mount('#app')
        }
        else
        {
            document.getElementById('login').click();
        }
    })
    .catch(err => 
    {
        console.log(err);
        window.location.href = "/error.html";
    });